<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
      <h4>出仓管理</h4>
    </div> -->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="" label-width="90px" size="mini">
        <div class="inpBox">
          <el-form-item label="队列">
            <el-select v-model="searchFrom.queueId" placeholder="请选择">
              <el-option v-for="item in duilieList" :key="item.queueName" :label="item.queueName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆号牌">
              <el-input size="mini" v-model.trim="searchFrom.vehicleNo" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="状态">
              <el-select v-model="searchFrom.jobStatus" placeholder="请选择">
                  <el-option v-for="item in zhuangtaiList" :key="item.itemNo" :label="item.showName" :value="item.itemNo">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="发货单位:">
            <el-select v-model="searchFrom.deliveryCompanyName"  placeholder="请选择" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.custerName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货单位:">
            <el-select v-model="searchFrom.receiveCompanyName"  placeholder="请选择" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.custerName"></el-option>
            </el-select>
          </el-form-item>
          <div style="margin:5px 0 5px 20px;">
            <el-form-item>
              <el-button type="primary" @click="searchFn" btnCode="01K00C0100" v-if="btnFlg[0]">查询</el-button>
              <el-button type="primary" @click="resetForm" btnCode="01K00C0200" v-if="btnFlg[1]">重置</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" @selection-change='selectGoods' style="width: 100%" height="100%" :cell-class-name="cellStyle" center border class="tableComent">
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column prop="province" label="操作" align="center" width="150">
            <template slot-scope="scope">
                <!-- 1显示通过/驳回 ，不是1显示记录 -->
                <div>
                    <el-button v-if="!scope.row.btnFlag" size="mini" type="text" @click="fangXing(scope.row)">特殊放行</el-button>
                    <el-button type="text" size="mini" v-if="scope.row.url" @click="lookImg(scope.row,2)">随车磅单</el-button>
                    <el-button type="text" size="mini" v-if="scope.row.unloadUrl" @click="lookImg(scope.row,2)">装卸凭证</el-button>
                </div>
            </template>
        </el-table-column>
        <!--<el-table-column type="selection" align="center" width="60" ></el-table-column>-->
        <el-table-column :show-overflow-tooltip="true" prop="lineUpNo" label="排队序号" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="vehicleNo" label="车牌号" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="mobilePhone" label="手机号" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="jobStatusName" label="状态" align="center" width="120">
          <template slot-scope="scope">
            <div>
              <!-- 1：排队中 2：已叫号 3：已过号 4：已失效 5：已进仓 6：进仓过磅完成 7：出仓过主磅完成 8：出仓过副磅完成 9：已出仓 -->
              <span v-if="scope.row.jobStatusName == '排队中'" style="color:blue">排队中
              </span>
              <span v-else-if="scope.row.jobStatusName == '已叫号'" style="color:red">已叫号
              </span>
              <span v-else-if="scope.row.jobStatusName == '已过号'" style="color:rgb(242, 159, 25)">
                已过号</span>
              <span v-else>{{ scope.row.jobStatusName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="entryWeighing" label="进仓过磅重量(吨)" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="exitMainWeighing" label="出仓过磅重量(吨)" align="center" width="150"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="exitCompositeWeighing" label="出仓过副磅重量(kg)"
          align="center" width="150"></el-table-column> -->
        <!-- <el-table-column :show-overflow-tooltip="true" prop="poundDifference" label="磅差" align="center">
            <template slot-scope="scope">
                <div>
                    <span v-if="scope.row.poundDifference&&scope.row.poundDifference!== 0&&scope.row.poundDifference !== 0.0">{{ scope.row.poundDifference }}%</span>
                    <span v-else-if="scope.row.poundDifference == 0||scope.row.poundDifference == 0.00">0.00%</span>
                    <span v-else></span>
                </div>
            </template>
        </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="mobilizationTime" label="进仓时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="entryWeighingTime" label="进仓过磅时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="exitMainTime" label="出仓过磅时间" align="center" width="160"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="exitCompositeTime" label="出仓过副磅时间" align="center" width="160"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="exFactoryTime" label="出仓时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="originalTon" label="装货地净重" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="grossWeight" label="装货地毛重" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="tareWeight" label="装货地皮重" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="deliveryCompanyName" label="发货单位" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="receiveCompanyName" label="收货单位" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unloadUser" label="装卸人" align="center" width="140"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unloadTime" label="装卸时间" align="center" width="170"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="statusUpdateUser" label="修改人" align="center" width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="statusUpdateTime" label="修改时间" align="center" width="160"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="searchFrom.pageNo" :page-sizes="[20, 30, 40, 50]" :page-size="searchFrom.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
    <el-dialog title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag" append-to-body width="800px" center>
      <div style="text-align: right;">
        <div id="printMe"  ref="print">
          <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import DonMessage from '@/utils/message'
import {
  // 列表查询
  cVhcNoColour // 车辆颜色
} from '@/api/consignment'
import { getExFactoryList, getQueueSettingsList, getJobStatusList, operateSpecialTreatment, findFlieUrl, findFlieUnloadUrl } from '@/api/lj'
import {
  getRelationCustomer
} from '@/api/wms-stock'
export default {

  data () {
    return {
      h: 500,
      disBtn: false,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      duilieList: [],
      zhuangtaiList: [],
      btnFlg: [],
      btnIdArr: ['01K00C0100', '01K00C0200'],
      lookImgFlag: false,
      imgUrl: '',
      RKData: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/factoryManagement')
    this.getList()
    getQueueSettingsList(this.searchFrom).then(res => {
      this.duilieList = res
    }).catch(err => {
      DonMessage.error(err.message)
    })
    getJobStatusList(this.searchFrom).then(res => {
      this.zhuangtaiList = res
      for (let i = 0; i < this.zhuangtaiList.length; i++) {
        if (this.zhuangtaiList[i].showName == '排队中') {
          this.zhuangtaiList.splice(i, 1)
          i--
        } else if (this.zhuangtaiList[i].showName == '已叫号') {
          this.zhuangtaiList.splice(i, 1)
          i--
        } else if (this.zhuangtaiList[i].showName == '已失效') {
          this.zhuangtaiList.splice(i, 1)
          i--
        } else if (this.zhuangtaiList[i].showName == '已过号') {
          this.zhuangtaiList.splice(i, 1)
          i--
        } else if (this.zhuangtaiList[i].showName == '已进仓') {
          this.zhuangtaiList.splice(i, 1)
          i--
        }
      }
    }).catch(err => {
      DonMessage.error(err.message)
    })
    // 字典-查询客户
    getRelationCustomer({
      // groupNo: "change_status"
    })
      .then((res) => {
        this.RKData = res
      })
      .catch((err) => {
        DonMessage.error(err.message)
      })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 165) + 'px'
  },
  methods: {
    // 特殊放行
    fangXing (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      operateSpecialTreatment({ id: row.id }).then(res => {
        DonMessage.success('操作成功')
        loading.close()
        this.getList()
      }).catch(err => {
        loading.close()

        DonMessage.error(err.message)
      })
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      row.btnFlag = false
      if (row.poundDifference > 0.5 && row.jobStatusName == '出仓过副磅完成') {
        return 'color1'
      } else {
        row.btnFlag = true
      }
    },

    // 审核
    passClick (row) {
      this.addFrom = { ...row }
      this.drawerFlag = true
    },
    successFn () {
      this.getList()
    },
    destroy () {
      this.drawerFlag = false
    },

    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 获取列表
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      getExFactoryList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        loading.close()
      }).catch(err => {
        loading.close()

        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 20

      }
      this.getList()
    },
    closeDialog () {
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    },
    lookImg (row, flag) {
      this.lookImgFlag = true
      if (flag == 1) {
        this.findFlieUrl(row.id)
      } else {
        this.findFlieUnloadUrl(row.id)
      }
    },
    findFlieUrl (id) {
      findFlieUrl({
        id: id
      }).then(res => {
        this.imgUrl = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    findFlieUnloadUrl (id) {
      findFlieUnloadUrl({
        id: id
      }).then(res => {
        this.imgUrl = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
    margin-left: 10px;
}

.el-table .success_class {
    color: green;
}

/deep/.color1 {
    background: red !important;
    ;
    color: #fff;
}

/deep/ .el-table .error_class {
    color: red;
}

.inpBox .el-date-editor {
    width: 350px !important;
}
</style>
